import React from 'react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';

export const DATE_RANGE_PRESETS = [
  { label: '7d', days: 7 },
  { label: '30d', days: 30 },
  { label: '90d', days: 90 },
];

export const toDateInputValue = (iso) => (iso ? iso.slice(0, 10) : '');

export const rangeForLastDays = (anchorIso, days) => {
  const to = new Date(anchorIso);
  const from = new Date(to);
  from.setUTCDate(from.getUTCDate() - days);
  return { from: from.toISOString(), to: to.toISOString() };
};

// Shared by the Flagged Threads tab and the Agent Analysis tab — both filter start_at against
// the same flagged_threads date bounds (from flaggedChatsAPI.getDateBounds()).
const DateRangeFilter = ({ range, bounds, onChange, label = 'Started' }) => {
  if (!range || !bounds?.max_start_at) return null;
  const minDate = toDateInputValue(bounds.min_start_at);
  const maxDate = toDateInputValue(bounds.max_start_at);

  const handleFromChange = (e) => {
    if (!e.target.value) return;
    onChange({ from: `${e.target.value}T00:00:00.000Z`, to: range.to });
  };

  const handleToChange = (e) => {
    if (!e.target.value) return;
    onChange({ from: range.from, to: `${e.target.value}T23:59:59.999Z` });
  };

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="font-mono text-[10px] uppercase tracking-wider text-ink-mute">{label}</span>
      <Input
        type="date" value={toDateInputValue(range.from)} min={minDate} max={maxDate}
        onChange={handleFromChange} className="h-8 w-auto text-xs"
      />
      <span className="text-xs text-ink-dim">to</span>
      <Input
        type="date" value={toDateInputValue(range.to)} min={minDate} max={maxDate}
        onChange={handleToChange} className="h-8 w-auto text-xs"
      />
      <div className="flex items-center gap-1 pl-2 border-l border-white/10">
        {DATE_RANGE_PRESETS.map((p) => (
          <Button key={p.days} variant="ghost" size="sm" onClick={() => onChange(rangeForLastDays(bounds.max_start_at, p.days))}>
            {p.label}
          </Button>
        ))}
        <Button variant="ghost" size="sm" onClick={() => onChange({ from: bounds.min_start_at, to: bounds.max_start_at })}>
          All time
        </Button>
      </div>
    </div>
  );
};

export default DateRangeFilter;
